import { Pagination } from '@components/Table/Pagination';
import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useCellPopover } from '@hooks/useCellPopover';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IMenu } from '@hooks/useMenu';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IDespesa, useDespesaStatusColor } from '@model/Despesa';
import { IDespesaFilter } from '@services/DespesaService';
import React from 'react';
import { DespesaReciboPopover } from './DespesaReciboPopover';

export type DespesaTableProps = {
    data: IData<IDespesa, IDespesaFilter>
    isLoading: boolean
    menu: IMenu
}

export function DespesaTable ({ data, isLoading, menu }: DespesaTableProps) {
    const despesaStatusColor = useDespesaStatusColor();

    const formatter = useFormatter();
    const cellPopover = useCellPopover<IDespesa>();

    return (
        <TableWrapper>
            <TableLinearLoading isLoading={isLoading} />
            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <Pagination pagination={data.pagination} />

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="despesaId">ID</TableSortCell>
                        <TableSortCell fieldName="empresa.nome">Empresa</TableSortCell>
                        <TableSortCell fieldName="descricao">Descrição</TableSortCell>
                        <TableSortCell fieldName="dataReferencia">Data</TableSortCell>
                        <TableSortCell fieldName="competencia">Competência</TableSortCell>
                        <TableSortCell fieldName="valor">Valor</TableSortCell>
                        <TableSortCell fieldName="status">Status</TableSortCell>
                        <TableHeaderCellAction />
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((despesa, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{despesa.despesaId}</TableKeyCell>
                                    <TableCell>{despesa.empresa.nome}</TableCell>
                                    <TableCell
                                        onMouseEnter={cellPopover.handleMouseOpen(despesa)}
                                        onMouseLeave={cellPopover.close}
                                    >
                                        {despesa.descricao}
                                    </TableCell>
                                    <TableCell>{formatter.toDate(despesa.dataReferencia)}</TableCell>
                                    <TableCell>{formatter.toCompetencia(despesa.competenciaReferencia)}</TableCell>
                                    <TableCell>{formatter.toFloat(despesa.valor)}</TableCell>
                                    <TableCell className={despesaStatusColor[despesa.status]}>{despesa.statusDescription}</TableCell>
                                    <TableCellAction onButtonClick={data.handleRowFocused(despesa, menu.open)} />
                                </TableRow>
                            )
                        })
                    }

                    <Pagination pagination={data.pagination} />

                </TableBody>
            </TableNoResult>
            
            {
                cellPopover.record !== undefined && cellPopover.record.reciboReferencia !== undefined && (
                    <DespesaReciboPopover cellPopover={cellPopover} despesa={cellPopover.record} />
                )
            }            
        </TableWrapper>
    )
}